import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment.prod';
import {Evaluacion} from '../evaluacion';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EvaluacionService {

  base = environment.base;
  constructor(private http: HttpClient) { }

  index() {
    return this.http.get(`${this.base}evaluaciones`);
  }
  show(evaluacion_id: number) {
    return this.http.get(`${this.base}evaluaciones/${evaluacion_id}`);
  }
  store(req: Evaluacion) {
    return this.http.post(`${this.base}evaluaciones`, req);
  }
  update(req:Evaluacion, evaluacion_id: number) {
    return this.http.put(`${this.base}evaluaciones/${evaluacion_id}`, req);
  }
  destroy(evaluacion_id: number) {
    return this.http.delete(`${this.base}evaluaciones/${evaluacion_id}`);
  }
  evaluacionesGrupo(grupo_id: number) {
    return this.http.get(`${this.base}evaluaciones-grupo/${grupo_id}`);
  }
}
